export class AppRedirectGuardOptions {
    constructor(
        public isAuthenticated: boolean) {}
}
